import { jsx as _jsx } from "react/jsx-runtime";
export const SvgPolygon = (props) => (_jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', xmlSpace: 'preserve', viewBox: '0 0 24 24', ...props, children: _jsx("path", { d: 'm17.2 4-10 4L4 20l16-4-2.8-12z' }) }));
//# sourceMappingURL=polygon.js.map